import { PurchaseLicenceContext } from "./PurchaseLicenceContext";

interface PurchaseLicenceProps {
  children: React.ReactNode;
  loading: boolean;
  onPurchaseLicence: (
    licenceId: string,
    licenceType?: string,
    numberOfUsers?: number
  ) => void;
}

const PurchaseLicenceProvider = ({
  children,
  loading,
  onPurchaseLicence,
}: PurchaseLicenceProps) => {
  return (
    <PurchaseLicenceContext.Provider
      value={{
        loading: loading,
        onPurchaseLicence: onPurchaseLicence,
      }}
    >
      {children}
    </PurchaseLicenceContext.Provider>
  );
};

export default PurchaseLicenceProvider;
